import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse, HttpEventType } from '@angular/common/http';
import { LoaderService } from './loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, throwError, timer } from 'rxjs';
import { finalize, catchError, raceWith, map, mergeMap, tap } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService, private snackBar: MatSnackBar) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.show();

    // Create a timer that hides the loader after 15 seconds regardless of request status
    const loaderTimeout = timer(15000).subscribe(() => {
      this.loaderService.hide();
    });



    return next.handle(req).pipe(
      tap(event => {
        // Hide loader if 204 No Content is returned
        if (event instanceof HttpResponse && event.status === 204) {
          this.loaderService.hide();
          loaderTimeout.unsubscribe(); // Cancel the 15-second timer
        }
      }),
      finalize(() => {
        this.loaderService.hide();
        loaderTimeout.unsubscribe(); // Always cancel the timer when request completes
      }),
      catchError((error: HttpErrorResponse) => {
        this.loaderService.hide();
        loaderTimeout.unsubscribe(); // Cancel the timer on error
        
        // Enhanced logging for debugging
        console.error('LoaderInterceptor - Error Details:', {
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          url: error.url,
          error: error.error
        });
        
        if (error.status === 429  ) {
          this.snackBar.open(
            `Pomalutku.... inni też chcą używać serwisu. Proszę spróbować ponownie później.`,
            'Zamknij',
            {
              duration: 6000,
              panelClass: ['error-snackbar'],
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            }
          );
        }
        
        return throwError(() => error);
      })
    );
  }
}
